var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectFilter',{ref:"select",staticClass:"fitlerSelect border-class",attrs:{"hide-details":"","type":"Period","value":_vm.value,"selectedItems":_vm.value,"multiple":"","returnObject":false},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }